
import {
  UserGroupIcon,
  Squares2X2Icon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  AcademicCapIcon,
    BookOpenIcon,
  CalculatorIcon,
  BeakerIcon, 
} from "@heroicons/react/24/outline";


export const statsData = [
  {
    id: 1,
    title: "65% Overall Progress",
    // value: "Access and Start your learning applications",
    icon: UserGroupIcon,
    arrowColor: "text-blue-600",
    
  },
  {
    id: 2,
    title: "140h Total  Hour Spent ",
    // value: "View your personal progress, milestones, and achievements",
    icon: Squares2X2Icon,
    arrowColor: "text-green-600",
  },
  {
    id: 3,
    title: "3 of 5 milestone Achieved",
    // value: "Share your feedback to improve learning apps",
    icon: ClipboardDocumentListIcon,
    arrowColor: "text-orange-600",
  },
 
];




export const performanceData = [
  { week: "Week 1", avg: 78 },
  { week: "Week 2", avg: 82 },
  { week: "Week 3", avg: 85 },
  { week: "Week 4", avg: 89 },
];

export  const milestones = [
  { name: "Reading Level 3", value: 34.2, color: "bg-green-500" },
  { name: "MathMaster", value: 34.2, color: "bg-blue-500" },
  { name: "Science Fundamentals", value: 34.2, color: "bg-yellow-500" },
  { name: "MathMaster", value: 34.2, color: "bg-orange-500" },
  { name: "MathMaster", value: 34.2, color: "bg-blue-500" },
];



// import { Squares2X2Icon, BeakerIcon, BookOpenIcon } from '@heroicons/react/24/outline';



export const applicationTableHeaders = [
  { key: "application", label: "APPLICATION" },
  { key: "educator", label: "EDUCATOR" },
  { key: "avgScore", label: "AVG SCORE" },
  { key: "location", label: "LOCATION" },
  { key: "usageHours", label: "USAGE HOURS" },
  { key: "completion", label: "COMPLETION" },
];


export const applications = [
  {
    name: 'Math Master',
    icon: Squares2X2Icon,
    educator: {
      name: 'Michel Shen',
      id: 'USR001',
      avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=MS',
    },
    avgScore: 86,
    location: 'California, USA',
    usageHours: 120,
    completion: 86,
  },
  {
    name: 'Science Lab',
    icon: BeakerIcon,
    educator: {
      name: 'Alice Johnson',
      id: 'USR002',
      avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=AJ',
    },
    avgScore: 92,
    location: 'New York, USA',
    usageHours: 80,
    completion: 96,
  },
  {
    name: 'History Hub',
    icon: BookOpenIcon,
    educator: {
      name: 'John Doe',
      id: 'USR003',
      avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=JD',
    },
    avgScore: 78,
    location: 'Texas, USA',
    usageHours: 60,
    completion: 70,
  },
];

export const ProgressBar = ({ percentage }) => {
  const barColor = percentage > 90 ? 'bg-green-500' : 'bg-orange-500';
  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5">
      <div className={`${barColor} h-2.5 rounded-full`} style={{ width: `${percentage}%` }}></div>
    </div>
  );
};

export const applicationUsageBarGraph = [
  { name: "Math Quest", usageHours: 60, lastWeek: 52 },
  { name: "Science Explorer", usageHours: 45, lastWeek: 39 },
  { name: "Reading Adventure", usageHours: 30, lastWeek: 27 },
  { name: "Art Studio", usageHours: 21, lastWeek: 19 },
];



export const metrics = [
  {
    id: 1,
    title: "Total students",
    value: "24",
    icon: Squares2X2Icon,
    bg: "bg-blue-100",
    iconBg: "bg-blue-600",
  },
  {
    id: 2,
    title: "Avg Completion",
    value: "87%",
    icon: Squares2X2Icon,
    bg: "bg-green-100",
    iconBg: "bg-green-600",
  },
  {
    id: 3,
    title: "Active Today",
    value: "18",
    icon: Squares2X2Icon,
    bg: "bg-orange-100",
    iconBg: "bg-orange-500",
  },

  
];

export const students = [
  {
    id: "USR001",
    name: "Michel Shen",
    avatar: "https://via.placeholder.com/40",
    progress: 96,
    progressColor: "bg-green-500",
    activity: "Math Quest - Level 5",
    lastLogin: "2 hours ago",
    status: "Active",
  },
  {
    id: "USR001",
    name: "Michel Shen",
    avatar: "https://via.placeholder.com/40",
    progress: 86,
    progressColor: "bg-orange-500",
    activity: "Math Quest - Level 5",
    lastLogin: "2 hours ago",
    status: "Active",
  },
  {
    id: "USR001",
    name: "Michel Shen",
    avatar: "https://via.placeholder.com/40",
    progress: 46,
    progressColor: "bg-blue-500",
    activity: "Math Quest - Level 5",
    lastLogin: "2 hours ago",
    status: "Active",
  },
];

// ✅ Configurable columns
export const columns = [
  {
    header: "STUDENT",
    render: (student) => (
      <div className="flex items-center space-x-2">
        <img
          src={student.avatar}
          alt={student.name}
          className="w-10 h-10 rounded-full"
        />
        <div>
          <p className="font-medium">{student.name}</p>
          <p className="text-xs text-gray-500">ID: {student.id}</p>
        </div>
      </div>
    ),
  },
  {
    header: "PROGRESS",
    render: (student) => (
      <div className="flex items-center space-x-2">
        <div className="w-32 h-2 bg-gray-200 rounded">
          <div
            className={`h-2 rounded ${student.progressColor}`}
            style={{ width: `${student.progress}%` }}
          ></div>
        </div>
        <span className="text-sm font-medium">{student.progress}%</span>
      </div>
    ),
  },
  {
    header: "RECENT ACTIVITY",
    render: (student) => (
      <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-md text-xs font-medium">
        {student.activity}
      </span>
    ),
  },
  {
    header: "LAST LOGIN",
    accessor: "lastLogin",
  },
  {
    header: "STATUS",
    render: (student) => (
      <span className="flex items-center space-x-1 text-green-600 font-medium">
        <span className="w-2 h-2 bg-green-500 rounded-full"></span>
        <span>{student.status}</span>
      </span>
    ),
  },
  {
    header: "ACTION",
    render: () => (
      <button className="text-blue-600 hover:underline">View Details</button>
    ),
  },
];

export const myGoals = [
  { title: "Reading Level", current: 2.2, target: 5.5, percentage: 85, color: "bg-green-500" },
  { title: "Math Level", current: 3, target: 6, percentage: 50, color: "bg-blue-500" },
  { title: "Writing Level", current: 1.5, target: 4, percentage: 40, color: "bg-yellow-500" },
];
